import { apiAxios } from '@/api/axios';
import type { Dispatcher } from '@/api/types/Dispatcher';

// Dispatchers service — wraps `GET /api/dispatchers`. Returns every KC user
// with the `dispatcher` realm role, used by `dispatchersSlice` to populate the
// sub→displayName resolver cache on app boot.

export const getDispatchers = async (): Promise<Dispatcher[]> => {
  const response = await apiAxios.get<Dispatcher[]>('/api/dispatchers');
  return response.data;
};
